import MuiRadioGroup from '@mui/material/RadioGroup';
import * as React from 'react';
import { IRadioGroupProps } from './radio-group-props';

export const RadioGroup = <TEnum extends string>({ children, ...props }: IRadioGroupProps<TEnum>) => {
  React.useEffect(() => {
    if (props.value === '') {
      throw new Error('RadioGroup value must be specified');
    }
  });

  return <MuiRadioGroup {...props}>{children}</MuiRadioGroup>;
};
